import { render } from "./CrStepSurface3Content.vue?vue&type=template&id=224134c4&scoped=true"
import script from "./CrStepSurface3Content.vue?vue&type=script&lang=js"
export * from "./CrStepSurface3Content.vue?vue&type=script&lang=js"

import "./CrStepSurface3Content.vue?vue&type=style&index=0&id=224134c4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-224134c4"]])

export default __exports__